import { PremiumDeliveryMoreInfoPopoutProps } from './PremiumDeliveryMoreInfoPopout';
import { getPremiumDeliveryFeatures, PremiumDeliveryOptions } from '@jbhi-fi/utils/src/premiumDelivery/premiumDelivery';

const premiumDeliveryOptionName = {
  unpackAndConnect: window.Jbhifi.premiumDeliveryConfig?.moreInfoHeading ?? 'Unpack & connect',
  premiumDelivery: window.Jbhifi.premiumDeliveryConfig?.moreInfoPremiumHeadingGeneral ?? 'Premium Delivery',
};

const getPremiumDeliveryExperiences = (deliveryOptions: any) => {
  return deliveryOptions
    ?.filter((option: any) => Object.values(PremiumDeliveryOptions).includes(option?.experienceName))
    ?.map((option: any) => option.experienceName);
};

const excludedFeaturesTypes: Array<string> = ["What's not included"];

export const getPremiumDeliveryMoreInfoProps = (
  productType: string = 'default',
  isPremiumDeliveryChangesEnabled: boolean = false,
  deliveryOptions: any = {}
): PremiumDeliveryMoreInfoPopoutProps => {
  return {
    featureTypes: isPremiumDeliveryChangesEnabled
      ? getPremiumDeliveryExperiences(deliveryOptions)
      : [premiumDeliveryOptionName.unpackAndConnect, premiumDeliveryOptionName.premiumDelivery],
    features: getPremiumDeliveryFeatures({ productType, page: 'popout' }),
    excludedFeaturesTypes: excludedFeaturesTypes ?? [],
  };
};
